
import { DealerFilterState } from "../types";

export interface PaginationOptions {
  page: number;
  limit: number;
  filters: DealerFilterState;
  coordinates?: {
    latitude: number;
    longitude: number;
  };
  city?: string;
  signal?: AbortSignal;
}

export interface PaginationResult<T> {
  data: T[];
  totalCount: number;
  hasMore: boolean;
}

export const calculatePagination = (page: number, limit: number) => {
  const offset = page * limit;
  return { offset, limit };
};

export const createPaginationResult = <T>(
  data: T[], 
  count: number | null, 
  offset: number, 
  limit: number
): PaginationResult<T> => {
  const totalCount = count || 0;
  const hasMore = (offset + data.length) < totalCount;

  return {
    data,
    totalCount,
    hasMore
  };
};
